






import { Component, Vue, Prop } from "vue-property-decorator";
import WebsiteBody from "../../components/WebsiteBody/index.vue";
import document from "../../assets/images/document.png";
import Bus from "../../utils/bus";
@Component({
  components: { WebsiteBody }
})
export default class NewsCenter extends Vue {
  @Prop(Boolean) private defaultArg1: string | undefined;
  private info = {
    icon: document,
    title: "新闻中心",
    type: "NEWS",
    list: [],
    total: 0
  };
  private form = {
    page: 1,
    limit: 15
  };
  private loading = true;
  created() {
    Bus.$on("newsCenter/currentChange", val => {
      this.currentChange(val);
    });
    Bus.$on("newsCenter/prevClick", () => {
      this.prevClick();
    });
    Bus.$on("newsCenter/nextClick", () => {
      this.nextClick();
    });
    this.getNewsList();
  }
  beforeDestroy() {
    const arr = ["currentChange", "prevClick", "nextClick"];
    arr.map(v => Bus.$off(v));
  }
  // 新闻列表
  async getNewsList() {
    this.loading = true;
    const res = await this.$axios("getNewsList", {
      page: this.form.page,
      limit: 15,
      type: "NEWS",
      isPublished: true
    });
    this.info.list = res.data.data.list;
    this.info.total = res.data.data.total;
    this.loading = false;
  }
  // currentPage 改变时会触发
  private currentChange(val) {
    this.form.page = val;
    this.getNewsList();
  }
  private prevClick() {
    this.form.page--;
  }
  private nextClick() {
    this.form.page++;
  }
}
